import { inject, Injectable, signal } from '@angular/core';
import { InboxService } from './inbox.service';

@Injectable({ providedIn: 'root' })
export class HeaderInboxBadgeService {
  private readonly inboxService = inject(InboxService);

  readonly unreadCount = signal(0);

  refresh(): void {
    this.inboxService.list().subscribe({
      next: (entries) => this.unreadCount.set(entries.filter((entry) => entry.unread).length),
      error: () => this.unreadCount.set(0),
    });
  }

  setUnreadCount(count: number): void {
    this.unreadCount.set(Math.max(0, count));
  }
}
